import { setExtractFileTextErrorModal } from "../store/workspace/slice";
import { useDispatch } from "../store/store";
import React, { useState } from "react";
import { pdfjs } from "react-pdf";
import mammoth from "mammoth";

pdfjs.GlobalWorkerOptions.workerSrc = `//unpkg.com/pdfjs-dist@${pdfjs.version}/build/pdf.worker.min.mjs`

type FileType = File | null;

export const useTextExtractor = (callback?: any) => {
    const dispatch = useDispatch();
    const [text, setText] = useState<string>("");
    const [warning, setWarning] = useState<string>("");
    const [file, setFile] = useState<FileType>(null);

    const handleFileChange = (event: React.ChangeEvent<HTMLInputElement>) => {
        const selectedFile = event.target.files ? event.target.files[0] : null;
        setFile(selectedFile);
        setWarning("");
        setText("");
    };

    const extractText = async () => {
        if (!file) return;
        const reader = new FileReader();
        setWarning("");

        if (file.type === "application/pdf") {
            reader.onload = async () => {
                try {
                    const typedArray = new Uint8Array(reader.result as ArrayBuffer);
                    const pdf = await pdfjs.getDocument(typedArray).promise;
                    if (pdf.numPages === 0) {
                        setWarning("The PDF file is locked or empty. Unable to extract text.");
                        dispatch(setExtractFileTextErrorModal(true));
                        return;
                    }
                    let extractedText = "";
                    for (let i = 0; i < pdf.numPages; i++) {
                        const page = await pdf.getPage(i + 1);
                        const textContent = await page.getTextContent();

                        let lastY: any = null;
                        let pageText = "";
                        textContent.items.forEach((item: any) => {
                            if (lastY !== null && Math.abs(item.transform[5] - lastY) > 5) {
                                pageText += "\n"; // Preserve line breaks
                            }
                            pageText += item.str + " ";
                            lastY = item.transform[5];
                        });
                        extractedText += pageText.trim() + "\n\n"; // Preserve paragraph spacing
                    }
                    setText(extractedText);
                    callback && callback(extractedText);
                } catch (error) {
                    setWarning("The PDF file might be locked. Unable to extract text.");
                    dispatch(setExtractFileTextErrorModal(true));
                }
            };
            reader.readAsArrayBuffer(file);
        } else if (file.type === "application/vnd.openxmlformats-officedocument.wordprocessingml.document") {
            reader.onload = async () => {
                const result = await mammoth.extractRawText({ arrayBuffer: reader.result as ArrayBuffer });
                setText(result.value);
                callback && callback(result.value);
            };
            reader.readAsArrayBuffer(file);
        } else if (file.type === "text/plain") {
            reader.onload = () => {
                setText(reader.result as string);
                callback && callback(reader.result as string);
            };
            reader.readAsText(file);
        } else {
            setWarning("Unsupported file type. Please upload a PDF, DOCX, or TXT file.");
            dispatch(setExtractFileTextErrorModal(true));
        }
    };

    return {
        file,
        text,
        setFile,
        warning,
        extractText,
        handleFileChange,
    };
};

// for (let i = 0; i < pdf.numPages; i++) {
//     // const page = await pdf.getPage(i + 1);
//     // const textContent = await page.getTextContent();
//     // extractedText += textContent.items.map((item: any) => item.str).join(" ") + "\n";
//     // // extractedText += pageText + "\n\n";
// }
// setText(extractedText);